import script from "./RoommateMatchView.vue?vue&type=script&setup=true&lang=js"
export * from "./RoommateMatchView.vue?vue&type=script&setup=true&lang=js"

import "./RoommateMatchView.vue?vue&type=style&index=0&id=520ab3f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520ab3f2"]])

export default __exports__